.kdx-hero-carousel {    
    background: $primary;
    position: relative;

    .kdx-carousel {

        &::before, &::after { display: none; }
        &.only-1-item {
            .kdx-hero-slide-item {
                .hero-content { padding-bottom: 24px; }
            }
        }
        .bullets-wrapper {
            
            &.internal {
                transform: none;
                left: 80px;        
            }
            .pause-action { 
                margin-left: 32px;
                border-radius: 100%;
                color: $heroCarouselDots;

                &:hover, &:focus { 
                    transform: scale(1.4); 
                    background: $heroCarouselPauseHoverBG;

                    svg { fill: $heroCarouselPauseHoverSvg; }
                }
            }
            .glide__bullets {
                button {
                    background: $heroCarouselDots;
                    
                    &.glide__bullet--active {
                        background: $heroCarouselDots;
                    }
                    &:hover, &:focus {
                        background: $heroCarouselDotsHover;
                    }
                }
            }
        }
        .controls button {
            background: $heroArrowBG;
            border: none;
            width: 44px;
            height: 44px;
            
            svg { fill: $heroArrowSvgColor; }
            &:hover, &:focus {
                background: $heroArrowBGHover;
                border-color: $heroArrowBGHover;

                svg { fill: $heroArrowSvgColorHover; }
            }
        }
    }
}





@include media-breakpoint-down(lg) {
    .kdx-hero-carousel {
        .hero-content {
            .container-fluid { padding: 0 80px; }
        }
    }
}

@include media-breakpoint-down(lg) {
    .kdx-hero-carousel {
        background: $heroCarouselOverlayMobile;

        .hero-content {
            .container-fluid { padding: 0 30px; }
        }
        .kdx-carousel {

            .bullets-wrapper {
                
                &.internal {
                    left: 50%;        
                    transform: translateX(-50%);
                    bottom: 40px;
                }
                .pause-action { margin-left: 16px;}                
            }
            .controls button {
                top: calc(230px / 2);
                transform: translateY(-50%);
            }
        }
    }
}
